import { defineStore } from 'pinia'
import { router } from '../helpers'
import { 
  login, logout, fetchChildren, fetchAccount, createChild, register, updateChild
} from '../helpers/api'
import { notify } from 'notiwind';

// rename to account store
export const useAuthStore = defineStore('auth', {
  state: () => ({
    authToken: null,
    children: {},
    currentChildId: null,
    returnUrl: null,
    user: null,
  }),
  actions: {
    login(username, password) {
      notify({
        group: "foo",
        type: "info",
        title: "Logging in",
        text: ""
      }, 4000)
      const authResponse = login(username, password).then(response => {
        localStorage.setItem('authToken', response.headers['authorization'])
        this.authToken = response.headers['authorization']
        this.user = response.data.status.data.user
        this.children = response.data.status.data.children.reduce((acc, child) => {
          acc[child.id] = child.attributes
          return acc
        }, {})
        setTimeout(() => {
          localStorage.setItem('authToken', '')
          this.authToken = ''
        }, 120 * 60 * 1000)
        router.push('/')
      }).catch(error => {
        notify({
          group: "foo",
          type: "error",
          title: "Ruh roh!",
          text: `Something went wrong! ${error}`
        }, 4000)
      })
    },
    logout() {
      logout().then(response => {
        localStorage.setItem('authToken', '')
        this.authToken = null
        router.push('/login')
      })
    },
    register(firstName, lastName, email, password) {
      notify({
        group: "foo",
        type: "info",
        title: "Creating an account",
        text: `One small step for ${firstName}, one giant leap for ${firstName}'s child!`
      }, 4000)
      register(firstName, lastName, email, password).then(response => {
        localStorage.setItem('authToken', response.headers['authorization'])
        this.authToken = response.headers['authorization']
        this.user = response.data.data
        setTimeout(() => {
          localStorage.setItem('authToken', '')
          this.authToken = ''
        }, 120 * 60 * 1000)
        router.push('/')
      }).catch(error => {
        notify({
          group: "foo",
          type: "error",
          title: "Ruh roh!",
          text: `Something went wrong! ${error}`
        }, 4000)
      })
    },
    async fetchChildren() {
      await fetchChildren().then(response => {
        this.children = response.children.reduce((acc, child) => {
          acc[child.id] = child.attributes
          return acc
        }, {})
      })
    },
    async hydrateAccount() {
      await fetchAccount().then(response => {
        this.user = response.user
        this.children = response.children.reduce((acc, child) => {
          acc[child.id] = child.attributes
          return acc
        }, {})
        this.currentChildId = response.children.length ? response.children[0].id :null
        notify({
          group: "foo",
          type: "success",
          title: "Welcome back!",
          text: "You're a rock star!"
        }, 4000)
      }).catch(error => {
        this.authToken = null
        notify({
          group: "foo",
          type: "error",
          title: "Ruh roh!",
          text: `Something went wrong! ${error}`
        }, 4000)
        router.push('/login')
      })
    },
    createChild(firstName, lastName, gender, birthYear, birthMonth, preterm_weeks) {
      notify({
        group: "foo",
        type: "info",
        title: `Adding ${firstName} to your crew`,
        text: ``
      }, 4000)
      createChild(firstName, lastName, gender, birthYear, birthMonth, preterm_weeks).then(response => {
        this.children[response.child.id] = response.child
        notify({
          group: "foo",
          type: "success",
          title: "Awesome!",
          text: `${response.child.first_name} is off to a great start!`
        }, 4000)
        router.push(`/children`)
      }).catch(error => {
        this.authToken = null
        notify({
          group: "foo",
          type: "error",
          title: "Ruh roh!",
          text: `Something went wrong! ${error}`
        }, 4000)
      })
    },
    updateChild(id, firstName, lastName, gender, birthYear, birthMonth, preterm_weeks) {
      updateChild(id, firstName, lastName, gender, birthYear, birthMonth, preterm_weeks).then(response => {
        this.children[id] = response.child
      }).catch(error => {
      })
    },
  },
  getters: {
    sortedChildren: (state) => {
      return Object.entries(state.children)
        .sort((a, b) => b[1].created_at - a[1].created_at)
        .map(([key, value]) => ({ id: key, ...value }))
    },
    currentChild: (state) => {
      return state.children[state.currentChildId]
    }
  }
});